module.exports = __webpack_public_path__ + "img/partThree.e00b63b6.png";